// Re-executa <script> do conteúdo WordPress injetado via v-html.
// O navegador não dispara scripts inseridos por innerHTML, então
// substituímos cada <script> por um novo nó equivalente.
export function executeWpScripts(container: HTMLElement): () => void {
  const scripts = container.querySelectorAll('script');

  scripts.forEach((oldScript) => {
    const newScript = document.createElement('script');

    if (oldScript.src) {
      newScript.src = oldScript.src;
    } else {
      newScript.textContent = oldScript.textContent;
    }
    oldScript.parentNode?.replaceChild(newScript, oldScript);
  });

  return () => {};
}
